const moduleExports = {};

moduleExports.onServiceWorkerUpdateReady = () => window.location.reload(true);

moduleExports.shouldUpdateScroll = (
  { routerProps: { location } }
) => {
  const hasAnchorLink = location.hash;

  // Using a very short timer to get get around 'scrollRestoration' calls, always
  // scroll the user to the top of the page on load, anchor link or not, using an
  // instant transition when we've got an anchor link to smoothly animate to shortly:
  setTimeout(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: hasAnchorLink ? 'instant' : 'smooth'
    });
  }, 150);

  // Then, nicely animate down to any anchor-linked content when supplied:
  if (hasAnchorLink) {
    setTimeout(() => {
      let [, thisAnchor] = location.hash.split('#');
      thisAnchor = document.getElementById(thisAnchor);
      if (thisAnchor) {
        thisAnchor.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }, 500);
  }

  // As we've no interest in storing and using page position (as it skips both the
  // Header nav and now breadcrumbs), we're always setting this to false to ensure
  // the above functionality works smoothly.
  return false;
};

module.exports = moduleExports;
